const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
const ETHEREUM_ADDRESS_PATTERN = /(0x[a-f0-9]{40})/;

export { ZERO_ADDRESS, ETHEREUM_ADDRESS_PATTERN };
